import { GET_COMPANY_DETAILS, GET_COMPANY_LOGO } from "resources/actionTypes";

export function fetchCompanyDetails(id) {
  const data = {
    id: id,
  };
  return {
    type: GET_COMPANY_DETAILS.GET_COMPANY_DETAILS_REQUESTED,
    payload: data,
  };
}

export function fetchCompanyLogo(id) {
  return {
    type: GET_COMPANY_LOGO.GET_COMPANY_LOGO_REQUESTED,
    payload: {
      id: id,
    },
  };
}
